/**
 * location 定位列表
 * @type {{}}
 */
import Vue from "vue";
import { Input, Icon, Cascader, Select, Option, Message, Table, Page, Modal } from "view-design";
import { mapMutations, mapState } from "vuex";
import { locationListColumns,getLocationListService,addLocationListService,editLocationListService,delLocationListService,moveLocationListService } from '@/service/location-service'
Vue.component('Input', Input);
Vue.component('Icon', Icon);
Vue.component('Cascader', Cascader);
Vue.component('Select', Select);
Vue.component('Option', Option);
Vue.component('Table', Table);
Vue.component('Page', Page);
import $event, { EVENT_NAME } from "@/utils/event-emitter";
const LocationList = {
    name:'LocationList',
    computed: {
        ...mapState({
            locationMenuArray: state => state.system.locationMenuArray, //定位菜单数据
            locationSelectedMenuId: state => state.system.locationSelectedMenuId, //选中的菜单Id
        }),
    },
    data() {
        return {
            locationListColumns:locationListColumns,
            locationListHeight:0, //表格高度
            windowWidth:0, //窗口宽度
            locationLoading:false,
            locationModalLoading:false,
            locationModalVisible:false,
            locationFlowVisible:false,
            locationFlowArray:[],
            locationFlowSearchArray:[],
            locationListArray:{}, //设备列表数据
            locationTypeList:[],
            selectId:'',
            locationId:'',
            locationFlowName:'',
            locationListParams:{ //提交的数据集
                name:'',
                currentPage: 1,  //当前页
                displayNumber:10 // 显示条数
            }
        }
    },
    created() {
        /**
         * 订阅分类菜单列表事件
         */
        $event.$on(EVENT_NAME.LOCATION_MENU_LIST, () => {
            this.locationListParams.currentPage = 1
            this.onLocationListAll().then()
        });
        this.onLocationListAll().then()
        this.onTableHeight()
    },
    mounted() {
        window.addEventListener('resize', this.onTableHeight)
    },
    methods: {
        ...mapMutations('system',['SET_DEVICE_INFO','SET_TAB_ID','SET_FLOW_ID']),
        /**
         * 计算table高度
         */
        onTableHeight(){
            this.locationListHeight = window.innerHeight - 208
            this.windowWidth = window.innerWidth
        },
        /**
         * 重置
         */
        onReset() {
            this.locationListParams.name = ''
            this.onLocationListAll().then()
        },
        /**
         * 搜索
         */
        onSearch(){
            this.onLocationListAll().then()
        },
        /**
         * 点击查看引用流程
         * @param list
         */
        onLookFlow(list){
            this.locationFlowArray = list.locationReference
            this.locationFlowSearchArray = list.locationReference
            this.locationFlowVisible = true
        },
        /**
         * 流程重置
         */
        onLocationFlowResetting() {
            this.locationFlowName = ''
            this.locationFlowSearchArray = this.locationFlowArray
            this.$forceUpdate()
        },
        /**
         * 搜索流程
         */
        onLocationFlowSearch() {
            if(this.locationFlowName === '') return
            this.locationFlowSearchArray = this.onFilter(this.locationFlowArray,this.locationFlowName)
        },
        /**
         * 过滤列表相同名称
         * @param array
         * @param content
         * @returns {*[]}
         */
        onFilter(array,content){
            return array.filter((value)=>{  //过滤数组元素
                return value.flowName.includes(content); //如果包含字符返回true
            });
        },
        /**
         * 跳转流程页面
         * @param obj
         */
        onFlowConfig(obj) {
            this.SET_FLOW_ID(obj.flowId)
            this.$router.push('/workflow/config')
        },
        /**
         * 新增
         */
        onAddList() {
            let resultRegular = this.locationListArray.content.some(item =>{
                if(item.name === '' || item.location === ''){
                    return true
                }
            })
            if(resultRegular){
                Message.warning('当前栏目有未填项目！')
            }else{
                this.locationListArray.content.push({
                    name:'',
                    location:'',
                    nameVisible:true,
                })
            }
        },
        /**
         * 验证新增条目
         * @param key
         */
        onAddLocationCheck(key){
            if(this.locationListArray.content[key].name === '' || this.locationListArray.content[key].location === ''){
                Message.warning('当前栏目有未填项目！')
            }else{
                if(this.locationListArray.content[key].id){
                    this.onEditListService(this.locationListArray.content[key].id,this.locationListArray.content[key].name,this.locationListArray.content[key].location).then()
                }else{
                    this.onAddListService(this.locationListArray.content[key].name,this.locationListArray.content[key].location).then()
                }
            }
        },
        /**
         * 编辑条目
         * @param key
         */
        onEditLocation(key){
            this.locationListArray.content[key].nameVisible = true
        },
        /**
         * 打开转移弹框
         * @param key
         */
        onMoveModal(key){
            this.locationTypeList = JSON.parse(JSON.stringify(this.locationMenuArray[0].children))
            this.locationModalVisible = true
            this.selectId = this.locationSelectedMenuId[2]
            this.locationId = this.locationListArray.content[key].id
        },
        /**
         * 转移条目
         */
        onMoveSubmit(){
            this.onMoveListService(this.locationId,this.selectId).then()
        },
        /**
         * 选中条目
         * @param id
         */
        onSelect(id){
            this.selectId = id
        },
        /**
         * 删除条目
         * @param key
         */
        onDelLocation(key){
            Modal.confirm({
                title: '提示',
                content: '<p>您确定要删除这条信息吗？</p>',
                onOk: () => {
                    this.onDelListService(this.locationListArray.content[key].id).then()
                }
            });
        },
        /**
         * 清空新增条目
         * @param key
         */
        onClearLocation(key){
            if(this.locationListArray.content[key].id){
                this.locationListArray.content[key].nameVisible = false
            }else{
                this.locationListArray.content.splice(key,1)
            }
        },
        /**
         * 发送当前页
         * @param number
         */
        onSearchPage(number){
            this.locationListParams.currentPage = number
            this.onLocationListAll().then()
        },
        /**
         * 发送每页显示的条数
         * @param number
         */
        onSearchPageSize(number){
            this.locationListParams.displayNumber = number
            this.onLocationListAll().then()
        },
        /**
         * 拉取定位列表
         */
        async onLocationListAll() {
            try {
                this.locationLoading = true
                this.locationListArray = {}
                let params = {
                    catalogueId:this.locationSelectedMenuId.length === 0?'':this.locationSelectedMenuId[2],
                    name:this.locationListParams.name,
                    displayNumber:this.locationListParams.displayNumber,
                    currentPage:this.locationListParams.currentPage
                }
                const { code,data } = await getLocationListService(params)
                if(code === 'SUCCESS'){
                    if(data.content.length!==0){
                        for(let i in data.content){
                            data.content[i].nameVisible = false
                        }
                    }
                    this.locationListArray = data
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
                this.locationLoading = false
            }catch (error){
                this.locationLoading = false
                console.log(error)
            }
        },
        /**
         * 添加定位列表
         */
        async onAddListService(name,location) {
            try {
                let params = {
                    catalogueId:this.locationSelectedMenuId.length === 0?'':this.locationSelectedMenuId[2],
                    name:name,
                    location:location,
                }
                const { code } = await addLocationListService(params)
                if(code === 'SUCCESS'){
                    this.onLocationListAll().then()
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
            }catch (error){
                console.log(error)
            }
        },
        /**
         * 编辑定位列表
         */
        async onEditListService(id,name,location) {
            try {
                let params = {
                    id:id,
                    catalogueId:this.locationSelectedMenuId.length === 0?'':this.locationSelectedMenuId[2],
                    name:name,
                    location:location,
                }
                const { code } = await editLocationListService(params)
                if(code === 'SUCCESS'){
                    this.onLocationListAll().then()
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
            }catch (error){
                console.log(error)
            }
        },
        /**
         * 删除定位列表
         */
        async onDelListService(id) {
            try {
                let params = {
                    id:id,
                }
                const { code } = await delLocationListService(params)
                if(code === 'SUCCESS'){
                    this.onLocationListAll().then()
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
            }catch (error){
                console.log(error)
            }
        },
        /**
         * 转移条目
         */
        async onMoveListService(id,catalogueId) {
            try {
                this.locationModalLoading = true
                let params = {
                    id:id,
                    catalogueId:catalogueId,
                }
                const { code } = await moveLocationListService(params)
                if(code === 'SUCCESS'){
                    this.selectId = ''
                    this.locationModalVisible = false
                    this.onLocationListAll().then()
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
                this.locationModalLoading = false
            }catch (error){
                this.locationModalLoading = false
                console.log(error)
            }
        },
    },
    destroyed () {
        $event.$off([EVENT_NAME.LOCATION_MENU_LIST,])
        window.removeEventListener('resize',this.onTableHeight)
    }
}
export default LocationList
